export * from "./verify-otp";
export * from "./request-otp";
export * from "./verify-token";
export * from "./logout";


export const ACTION_AUTHEN_REQUEST_OTP =  "AUTHEN_REQUEST_OTP";
export const ACTION_AUTHEN_REQUEST_OTP_SUCCESS= "AUTHEN_REQUEST_OTP_SUCCESS";
export const ACTION_AUTHEN_REQUEST_OTP_ERROR= "AUTHEN_REQUEST_OTP_ERROR";
export const ACTION_AUTHEN_VERIFY_OTP= "AUTHEN_VERIFY_OTP";
export const ACTION_AUTHEN_VERIFY_OTP_SUCCESS= "AUTHEN_VERIFY_OTP_SUCCESS";
export const ACTION_AUTHEN_VERIFY_OTP_ERROR= "AUTHEN_VERIFY_OTP_ERROR";
export const ACTION_AUTHEN_VERIFY_TOKEN= "AUTHEN_VERIFY_TOKEN";
export const ACTION_AUTHEN_VERIFY_TOKEN_SUCCESS= "AUTHEN_VERIFY_TOKEN_SUCCESS";
export const ACTION_AUTHEN_VERIFY_TOKEN_ERROR= "AUTHEN_VERIFY_TOKEN_ERROR";
export const ACTION_AUTHEN_TOKEN_EXPIRE="AUTHEN_TOKEN_EXPIRE";
    